module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "xs12": "",
      "md3": "",
      "offset-md1": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('v-list-group', {
      key: item.title,
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item"
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.action))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _vm._l((item.items), function(subItem) {
      return _c('v-list-item', {
        key: subItem.title
      }, [_c('v-list-tile', {
        attrs: {
          "router": "",
          "href": '/user/' + subItem.value
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(subItem.title))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(subItem.action))])], 1)], 1)], 1)
    })], 2)
  }))], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": ""
    }
  }, [_c('v-content', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6283e7b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 782
// module chunks = 1